<template>
  <div id="app">
    <app-nav v-show="showNav"></app-nav>
    <div class="row small-collapse" :class="{'large-uncollapse': twoColumnsLayout}">
      <div class="small-12 column" :class="{'large-8': twoColumnsLayout}">
        <router-view class="page-content"></router-view>
      </div>
      <div v-if="twoColumnsLayout" class="search-column show-for-large large-4 column">
        <router-view name="search"></router-view>
      </div>
    </div>
    <app-footer v-show="showFooter" ></app-footer>
  </div>
</template>

<script>
  import Nav from 'components/layout/Nav'
  import Footer from 'components/layout/Footer'
  import { injectTagCommanderScripts } from './tagcommander'

  export default {
    name: 'app',
    data () {
      return {
        twoColumnsPages: [
          'order-list'
        ]
      }
    },
    computed: {
      twoColumnsLayout () {
        return this.$route.name === 'order-list'
      },
      showNav () {
        return this.$route.name !== 'login'
      },
      showFooter () {
        return this.$route.name !== 'login' && this.$route.name !== 'search'
      }
    },
    components: {
      'app-nav': Nav,
      'app-footer': Footer
    },
    mounted () {
      injectTagCommanderScripts()
    }
  }
</script>

<style lang="scss" src="scss/main.scss"></style>

<style scoped lang="scss" rel="stylesheet/scss">
  @import '~scss/variables';
  @import '~foundation';

  #app {

    position: relative;

    .nav {
      position: fixed;
      z-index: 100;
      top: 0;
      left: 0;
      right: 0;
    }

    .footer {
      /* Medium and up */
      @include breakpoint(large) {
        margin-top: 0;
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
      }
    }

    // Login page is displayed without header / footer
    body:not(.login) & {
      .page-content {
        padding-top: 55px;

        @include breakpoint(large) {
          padding-bottom: 50px;
        }
      }
    }

    body.login & {
      height: 100%;
      background-color: $somfy;

      > .row {
        height: 100%;

        > .column {
          height: 100%;
        }
      }
    }

    body.order-list & {
      /* Medium and up */
      @include breakpoint(large) {
        background-color: $grey-10;

        .search-column {
          position: relative;

          // .page-order-lists,
          .page-search {
            position: fixed;
            top: 55px;
            right: 0;
          }
        }
      }
    }
  }
</style>

<!-- Non scopped background style -->
<style lang="scss">
  @import '~scss/variables';
  @import '~foundation';

  body.order-list {
    /* Medium and up */
    @include breakpoint(large) {
      background-color: $grey-10;
    }
  }
</style>



// WEBPACK FOOTER //
// App.vue?502acd7e